import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

const ItemPreviewSheet = ({ isOpen, onClose, children }) => {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      event.stopPropagation();
      onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="md:hidden fixed inset-0 z-[70]"
      role="dialog"
      aria-modal="true"
      aria-label="Item preview"
    >
      <div
        className="absolute inset-0 bg-black bg-opacity-40"
        onClick={onClose}
      />
      <div className="absolute inset-x-0 bottom-0 max-h-[85vh] overflow-y-auto rounded-t-2xl border-t-2 border-neutral-900 bg-neutral-50 px-4 pb-5 pt-2">
        <div className="mx-auto mb-2 h-1 w-9 rounded-full bg-neutral-300" aria-hidden="true" />
        <div className="mb-3 flex items-center justify-between gap-3">
          <p className="text-sm font-semibold text-neutral-800">Item preview</p>
          <button
            type="button"
            ref={closeButtonRef}
            onClick={onClose}
            className="p-1.5 rounded-md text-neutral-500 hover:bg-neutral-200 hover:text-neutral-900 transition-colors"
            aria-label="Close preview"
          >
            <X size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default ItemPreviewSheet;
